export default __webpack_public_path__ + "static/media/harvard.fac95ead.webp";